import { createFileRoute } from '@tanstack/react-router'
import MouvementsTab from '@features/stock/components/MouvementsTab'

export const Route = createFileRoute('/_app/stock/mouvements/')({
  component: MouvementsTab,
})
